import { omit, mapValues } from 'lodash';
import { updateIn } from 'icepick';
import coreWebsiteMigrations from 'nucleus-widgets/migrations/website';
import { MAX_WEBSITE_VERSION } from './transformWebsiteMaxVersion';

const removeDeletedWidgets = (website, contactCustomFields) => {
  const deleteWidgetIds = Object.keys(website.layoutItems).filter(widgetId => {
    const layoutItem = website.layoutItems[widgetId];
    switch (layoutItem.widgetType) {
      case 'EventCustomContactFieldText':
      case 'EventCustomContactFieldSingleChoice':
      case 'EventCustomContactFieldMultiChoice':
      case 'EventCustomContactFieldDateTime': {
        // Remove custom fields that have been deleted from the account
        const fieldId = layoutItem.config.fieldId;
        return !contactCustomFields[fieldId];
      }
      default:
        return false;
    }
  });

  return updateIn(website, ['layoutItems'], layoutItems =>
    mapValues(omit(layoutItems, deleteWidgetIds), layoutItem =>
      updateIn(layoutItem, ['layout', 'childIds'], childIds => childIds.filter(id => !deleteWidgetIds.includes(id)))
    )
  );
};

/**
 * Removes custom fields from the website if they're not in
 * the account snapshot
 */
export function removeDeletedContactFields(website, account) {
  return removeDeletedWidgets(website, account.contactCustomFields);
}

/**
 * Runs the migrations on the website to account for code changes.
 * Also removes custom contact fields that no longer exist.
 */
export default async function transformWebsite(website, account) {
  const coreMigratedSite = coreWebsiteMigrations(
    removeDeletedContactFields(website, account));

  if (coreMigratedSite.eventVersion && coreMigratedSite.eventVersion === MAX_WEBSITE_VERSION) {
    return coreMigratedSite;
  }

  const eventWebsiteMigrations = (await import(/* webpackChunkName: "migrations" */ '../migrations/website')).default;

  return eventWebsiteMigrations(coreMigratedSite);
}

